import React from 'react';
import { v4 as uuid } from 'uuid';
import { Icon } from 'Permafrost/index';
import { StyledSearchField } from './SearchField.styles';
export const SearchField = (props) => {
    const { className = '', inputProps, onChange, onKeyUp, placeholder, value } = props;
    const id = uuid();
    return (React.createElement(StyledSearchField, { className: className, "data-cy": props['data-cy'], id: props.id },
        React.createElement("label", { htmlFor: id },
            React.createElement(Icon, { name: "fa-search", ariaLabel: "search" })),
        React.createElement("input", Object.assign({ type: "search", id: id, placeholder: placeholder, value: value, onChange: onChange, onKeyUp: onKeyUp }, inputProps))));
};
export default SearchField;
//# sourceMappingURL=SearchField.js.map